<template>
  <my-giving-layout :enable-scroll-event="true">
    <div class="bg-[#F6F4F0] pb-[64px]">
      <BackButton class="w-full px-[20px] mb-[16px]" :customBack="back" />
      <h1
        class="font-bold text-[1.5rem] md:text-[2rem] lg:text-[2.25rem] leading-[2rem] md:leading-[2.5rem] lg:leading-[2.75rem] ml-[28px] md:ml-[32px] lg:ml-[36px] pb-[26px] md:pb-[30px] lg:pb-[34px]"
      >
        FAQs
      </h1>
      <div class="px-[20px] h-full">
        <FilterAccordian
          :title="Q1Data.title"
          :description="Q1Data.description"
          additionalCollapseClass="mb-[16px]"
        />
        <FilterAccordian
          :title="Q2Data.title"
          :description="Q2Data.description"
          additionalCollapseClass="mb-[16px]"
        />
        <FilterAccordian
          :title="Q3Data.title"
          :description="Q3Data.description"
          additionalCollapseClass="mb-[16px]"
        />
        <FilterAccordian
          :title="Q4Data.title"
          :description="Q4Data.description"
          additionalCollapseClass="mb-[16px]"
        />
      </div>
    </div>
  </my-giving-layout>
</template>

<script>
import FilterAccordian from '@/components/MyGiving/Common/FilterAccordian.vue';
import BackButton from '@/components/common/BackButton.vue';
import MyGivingLayout from '@/components/MyGivingLayout.vue';

export default {
  components: { FilterAccordian, BackButton, MyGivingLayout },
  data() {
    return {
      Q1Data: {
        title: 'What is my personalised reference number and why do I need it?',
        description: `Your personalised reference number
        is 12 characters comprising:<br/><br/>
        1. The last 4 characters of your NRIC<br/>
        2. Birth date in DDMM format<br/>
        3. Month of giving<br/>
        4. Nature of giving<br/><br/>(T- Tithes, B - Building Fund, M - Missions, H - Heart Community Services)<br/><br/>
        e.g. 123A3108DECT<br/><br/>GENS - GenerationS Fund<br/>*Month is not required<br/><br/>
        e.g. 123A3108GENS<br/><br/>With your personalised reference number, your giving records can be accurately reflected for your viewing.`,
      },
      Q2Data: {
        title:
          'What if I have not been using my personalised reference number, or filled in the wrong number?',
        description: `Your giving records may not be accurately reflected. Do email us at <br/>
        <a href="mailto:accounts@heartofgodchurch.org" class="underline">accounts@heartofgodchurch.org</a>
        and provide the details of your transaction and
        the accurate reference number. We will be happy to assist you in updating your records.`,
      },
      Q3Data: {
        title: 'What should I do if I have questions about my giving records?',
        description: `Please contact us at<br/><a href="mailto:accounts@heartofgodchurch.org" class="underline">accounts@heartofgodchurch.org</a>
        and we will be happy to assist you in updating your records.`,
      },
      Q4Data: {
        title: 'How is my giving information protected?',
        description: `We are committed to protecting your<br/>privacy and safeguarding your personal
        data. All information on MyGiving is kept
        confidential and secure, in accordance with the Personal Data Protection Act
        2012. For more details, visit <a href="#" onclick="window.open('https://hogc.sg/privacy', '_system', 'location=yes'); return false;"
        class="underline">hogc.sg/privacy</a>.`,
      },
    };
  },
  methods: {
    back() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.replace('/my-giving');
      }
    },
  },
};
</script>
